import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

import { Box, Row, Text, Img } from "../../comps";
import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Theme } from "../../theme/theme-provider";

import { faPlus, faCheck } from "@fortawesome/free-solid-svg-icons";

const Wrapper = styled(Row)`
  width: 100%;
  height: 50px;
  align-items: center;
  justify-content: space-between;
  &:hover {
    background: ${({ theme }) => theme.color.BLACK_0};
  }
`;

export default ({ song, addSongs }) => {
  const [added, setAdded] = useState(false);
  const { title, thumbnails } = song;
  const onClick = async () => {
    const done = await addSongs([song]);
    if (done) setAdded(true);
  };
  return (
    <Wrapper>
      <Img
        height="84%"
        src={thumbnails && (thumbnails.mediumUrl || thumbnails.standardUrl)}
      />
      <Text
        width="60%"
        marginLeft="5px"
        fontSize="16px"
        fontWeight="520"
        oneline={true}
        color={Theme.textColor.light}
      >
        {title}
      </Text>
      <MaterialIconButton onClick={onClick}>
        <FontAwesomeIcon
          style={{ color: Theme.color.WHITE_2, fontSize: "16px" }}
          icon={added ? faCheck : faPlus}
        />
      </MaterialIconButton>
    </Wrapper>
  );
};
